/*
A simple notification system that can be used to display information, warnings and errors to the user.
Display of notifications are controlled completely by CSS by adding/removing the @options.classes.show class.
This allows styling/animation using CSS rather than hardcoding styles.
*/
class CorrectorNotification extends CorrectorDelegator {

	///////////////////////////////////////////////////////////////////////////////////////////
	//  CONSTRUCTOR
	///////////////////////////////////////////////////////////////////////////////////////////

	/*
	CONSTRUCTOR: Creates an instance of  Notification and appends it to the document body.

	options - The following options can be provided.
		classes - A Object literal of classes used to determine state.
		html    - An HTML string used to create the notification.

	Examples:
	// Displays a notification with the text "Hello World"
	notification = new CorrectorNotification
	notification.show("Hello World")
	*/
	constructor(options) {
		// TODO: Can't use 'this' before super, so have to declare html local and use that, then set the class property
		options = options || {};
		const html = "<div class='corrector-notice'></div>";
		super( $(html).appendTo(document.body)[0], options );
	}

	properties() {
		super.properties();
		// Sets events to be bound to the @element.
		this.events = {
			"click": "hide"
		}
		this.options.html = "<div class='corrector-notice'></div>";// See constructor
		this.options.classes = {
			show:    "corrector-notice-show",
			info:    "corrector-notice-info",
			success: "corrector-notice-success",
			error:   "corrector-notice-error"
		};
	}


	///////////////////////////////////////////////////////////////////////////////////////////
	//  PUBLIC METHODS
	///////////////////////////////////////////////////////////////////////////////////////////

	/*
	PUBLIC: Displays the notification with message and optional status.
	The message will hide itself after 5 seconds or if the user clicks on it.

	message - A message String to display (HTML will be escaped).
	status  - A status constant. This will apply a class to the element for styling. (default: CorrectorNotification.INFO)

	Examples:

	// Displays a notification with the text "Hello World"
	notification.show("Hello World")

	// Displays a notification with the text "An error has occurred"
	notification.show("An error has occurred", CorrectorNotification.ERROR)

	Returns itself.
	*/
	show(message, status=CorrectorNotification.INFO) {
		this.currentStatus = status;

		$(this.element)
			.addClass(this.options.classes.show)
			.addClass(this.options.classes[this.currentStatus])
			.html(CorrectorUtil.escape(message || ""));

		setTimeout(this.hide.bind(this), 5000);

		return this;
	}

	/*
	PUBLIC: Hides the notification.

	Examples:
	notification.hide()

	Returns itself.
	*/
	hide() {
		if (this.currentStatus == null) {
			this.currentStatus = CorrectorNotification.INFO;
		}
		$(this.element)
			.removeClass(this.options.classes.show)
			.removeClass(this.options.classes[this.currentStatus]);
		return this;
	}

}

/*
Constants for controlling the display of the notification.
Each constant adds a different class to the CorrectorNotification#element.
*/
CorrectorNotification.INFO    = 'info';
CorrectorNotification.SUCCESS = 'success';
CorrectorNotification.ERROR   = 'error';

// Attach notification methods to the Corrector object on document ready.
jQuery(document).ready(function() {
	const notification = new CorrectorNotification();
	Corrector.showNotification = notification.show.bind(notification);
	Corrector.hideNotification = notification.hide.bind(notification);
});
